import { Link } from 'react-router-dom';
import type { Game } from '@/mocks/games';

interface GameCardProps {
  game: Game;
}

export default function GameCard({ game }: GameCardProps) {
  return (
    <Link
      to={`/category/${game.categorySlug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[4/3] overflow-hidden">
        <img
          src={game.image}
          alt={game.title}
          title={`${game.title} - 黄油在线玩免费在线游戏`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex gap-1.5 flex-wrap">
          {game.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-md">
              热门
            </span>
          )}
          {game.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-md">
              新游
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 bg-background-950/60 rounded-md text-background-50 text-xs">
          <i className="ri-star-fill text-primary-400 text-xs"></i>
          <span>{game.rating}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {game.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
          {game.description}
        </p>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-foreground-400">{game.players}人在玩</span>
          <div className="flex gap-1 flex-wrap">
            {game.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-1.5 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}